import * as getters from "../../baseQuestion/staticDDL/store/getters";
import * as mutations from "../../baseQuestion/staticDDL/store/mutations";
import * as actions from "../../baseQuestion/staticDDL/store/actions";
import { state as base_state } from "../../baseQuestion/staticDDL/store/state";

function state() {
	return Object.assign(
		{
			multi_field_parent: "q_guardian",
			options: [
				{
					value: "Esq",
					text: "Esq"
				},
				{
					value: "II",
					text: "II"
				},
				{
					value: "III",
					text: "III"
				},
				{
					value: "IV",
					text: "IV"
				},
				{
					value: "V",
					text: "V"
				},
				{
					value: "Jr",
					text: "Jr"
				},
				{
					value: "Sr",
					text: "Sr"
				}
			]
		},
		base_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
